import { useNavigate } from "react-router-dom";

export const Logo = () => {
  const navigate = useNavigate();
  return (
    <div className="flex items-center cursor-pointer" onClick={() => navigate('/')}>
      <img 
        src="/optimized/main-logo.webp" 
        alt="ApexBet Logo" 
        className="h-auto w-auto max-h-12"
      />
    </div>
  );
};
